import { useState } from 'react';
import TablePagination from '@mui/material/TablePagination';
import "../../variables.css";

const PaginationUI = (props) => {
    const { pagination, callBack } = props;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        callBack({ pageNo: newPage + 1 , rowsPerPage: rowsPerPage });
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        callBack({ pageNo: 1, rowsPerPage: parseInt(event.target.value, 10) });
    };

    return(
        <TablePagination
            component="div"
            count={ pagination.totalEntries }
            page={ page }
            onPageChange={ handleChangePage }
            rowsPerPage={ rowsPerPage }
            onRowsPerPageChange={ handleChangeRowsPerPage }
        />
    )
}

export default PaginationUI;